import Close16 from '@carbon/icons-react/es/close/16';
import { DrawerProps } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { ProductiveHeading03, BodyShort01, TextWrapper } from 'ozone/atoms';
import { Drawer as DrawerAtom } from './drawer';

export const CustomLayoutDrawer = styled(DrawerAtom)`
  .ant-drawer-body {
    padding: 0;
  }
`;

const Divider = styled.div`
  border-top: 1px solid var(--border-color);
`;

const Separator = styled.div`
  margin: 0 var(--spacing-02);

  &::after {
    content: '·';
  }
`;

const Text = styled(TextWrapper)`
  padding: 0;
`;

const Title = styled(ProductiveHeading03).attrs({ as: Text })``;

const Content = styled(BodyShort01)``;

const Footer = styled.div``;

const DrawerComponent = styled.div`
  --popover-spacing: var(--spacing-05);
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: stretch;
  height: 100%;

  ${Title} {
    padding: var(--popover-spacing) var(--popover-spacing)
      var(--popover-spacing);
    background: var(--coolest-gray-10);
    flex: 0 0 auto;
  }

  ${Content} {
    padding: var(--popover-spacing) var(--popover-spacing)
      calc(2 * var(--popover-spacing));
    flex: 1;
    overflow-y: auto;
  }

  ${Footer} {
    border-top: 1px solid var(--border-color);
    flex: 0 0 auto;
    padding: var(--popover-spacing);
  }

  ${Divider} {
    margin-top: var(--popover-spacing);
  }
`;

type CustomLayoutDrawerContent = typeof DrawerComponent & {
  Title: typeof Title;
  Content: typeof Content;
  Divider: typeof Divider;
  Separator: typeof Separator;
  Footer: typeof Footer;
};

const CustomLayoutDrawerContent: CustomLayoutDrawerContent =
  DrawerComponent as any;

CustomLayoutDrawerContent.Title = Title;
CustomLayoutDrawerContent.Content = Content;
CustomLayoutDrawerContent.Divider = Divider;
CustomLayoutDrawerContent.Separator = Separator;
CustomLayoutDrawerContent.Footer = Footer;

export { CustomLayoutDrawerContent };
export const DefaultCustomLayoutDrawerProps: DrawerProps = {
  placement: 'right',
  closable: true,
  closeIcon: <Close16 />,
  mask: true,
  destroyOnClose: true,
};
